import { render, staticRenderFns } from "./SummitControl.vue?vue&type=template&id=135b2ec2&scoped=true"
import script from "./SummitControl.vue?vue&type=script&lang=js"
export * from "./SummitControl.vue?vue&type=script&lang=js"
import style0 from "./SummitControl.vue?vue&type=style&index=0&id=135b2ec2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "135b2ec2",
  null
  
)

export default component.exports